import InstitutionForm from './Form'

export default InstitutionForm
